import {asset} from 'imba';
import url from './E.svg';

export default /* @__PURE__ */ asset({
	url: url,
	type: 'svg',
	meta: {"attributes":{"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"},"flags":[],"content":"\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16 12C16 10.8954 16.8954 10 18 10H30C31.1046 10 32 10.8954 32 12C32 13.1046 31.1046 14 30 14H20V22H30C31.1046 22 32 22.8954 32 24C32 25.1046 31.1046 26 30 26H20V34H30C31.1046 34 32 34.8954 32 36C32 37.1046 31.1046 38 30 38H18C16.8954 38 16 37.1046 16 36V12Z\" fill=\"#333333\"/>\n\n"},
	toString: function(){ return this.url;}
})